import { Pipe, PipeTransform } from '@angular/core';
import { ProjectStatus } from 'src/app/classes/project.class';

@Pipe({
    name: 'projectStatus',
    standalone: true,
})
export class ProjectStatusPipe implements PipeTransform {
    transform(status: number): boolean {
        return (
            status === ProjectStatus.FinGereed ||
            status === ProjectStatus.Afgesloten2023 ||
            status === ProjectStatus.Afgesloten2024 ||
            status === ProjectStatus.Afgesloten2025 ||
            status === ProjectStatus.Afgemeld
        );
    }
}
